import {
    TextHelper,
    UrlHelper,
    ArrayHelper
} from './prismicHelpers/PrismicHelpers';

export const layoutHelperDynamicURLs = response => {
    const layoutData = response.results[0].data;

    let footerObject = {
        logo: UrlHelper(layoutData.footer_logo),
        address: ArrayHelper(layoutData.footer_address),
        links: layoutData.policy_footer_links.map(policy_link => {
            return {
                title: TextHelper(policy_link.title),
                url: TextHelper(policy_link.url)
            }
        })
    };

    return {
        footer: footerObject
    };
}




// WEBPACK FOOTER //
// src/client/helpers/LayoutHelpers.js